module.exports = __webpack_public_path__ + "src/font/woff/ada293a44f5ee12a368fa75d4e7f360f.woff";